import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  Input,
  ChangeDetectionStrategy,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { environment } from 'src/environments/environment';
import { Subject, takeUntil } from 'rxjs';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { ToastrService } from 'ngx-toastr';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/shareModule/states/app.state';
import { loadUser } from 'src/app/shareModule/states/user-details';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
@Component({
  selector: 'app-nearby-all-services',
  templateUrl: './all-services.component.html',
  styleUrls: ['./all-services.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class NearbyAllServicesComponent implements OnChanges, OnInit {
  private $destroy = new Subject<void>();

  constructor(
    private customerService: CustomerService,
    private commonService: CommonService,
    private auth: AuthServiceService,
    private sharedService: SharedService,
    private cdr: ChangeDetectorRef,
    private toastr: ToastrService,
    private store: Store<AppState>,
    private modalService: NgbModal,
    private local: LocalServiceService,
  ) {}
  private fetchPromos() {
    this.auth
      .getAllUpgradedPromo(this.local.getUser()?.region ?? 42)
      .subscribe({
        next: (data) => {
          this.promos = data.body;
        },
        error: console.error,
      });
  }
  ngOnInit(): void {
    if (this.sharedService.isBrowser()) {
      // this.fetchPromos()
      this.local
        .getUserDetailsObserver()
        .pipe(takeUntil(this.$destroy))
        .subscribe((isLoggedIn) => {
          if (isLoggedIn) {
            try {
              this.locationOfUser = JSON.parse(this.local.getUser()?.latLong);
            } catch (e) {}
          } else {
            this.locationOfUser = '';
          }
        });
    }
  }
  public modalRef: any = null;

  @Input()
  public userRegionId: any;
  @Input()
  public userRegionName: any;
  @Input()
  public userId: any;

  @Input()
  public hiddenCategoryTab: any;

  @Output()
  public onViewProducts = new EventEmitter();

  public promos = [];
  public viewProductDetails(prod) {
    this.onViewProducts.emit(prod);
  }

  public areThereMore = false;
  public selectedTab = '';

  public onProductsSwiper(swiper) {
    this.areThereMore = !swiper.isEnd;
   // this.cdr.detectChanges();
  }
  public onProductSlideChange(swiper) {
    this.areThereMore = !swiper.isEnd;
    this.cdr.detectChanges();
  }

  carouselOptions: any = {
    spaceBetween: 10,
    slidesPerView: 'auto',
    pagination: false,
    slidesPerGroup: 2,
    freeMode: true,
  };

  public promoCarouselOptions: any = {
    spaceBetween: 10,
    slidesPerView: 'auto',
    pagination: false,
  };

  public locationOfUser = null;
  //Technology / Cleaner / Pets / Education
  bottomCategories = [
    { name: 'Education' },
    { name: 'Beauty', need: 'Beauty & Grooming' },
    { name: 'TCM' },
    { name: 'Cleaning' },
    { name: 'Pets' },
    { name: 'Plumbing' },
  ];

  public tabs: {
    name: string;
    value: string;
    icon: string;
    hidden?: boolean;
    checked?: boolean;
  }[] = [
    { name: 'Popular', value: 'popular', icon: 'fas fa-fire', checked: true },
    { name: 'Latest', value: 'latest', icon: 'fas fa-clock', checked: true },
    { name: 'Friends', value: 'friends', icon: 'fas fa-users' },
    {
      name: 'Food & Beverage',
      value: 'food-beverage',
      icon: 'fas fa-utensils',
      checked: true,
    },
    {
      name: 'Local Delights',
      value: 'local-delights',
      icon: 'fas fa-hamburger',
      checked: true,
    },
    { name: 'Free', value: 'free', icon: 'fas fa-gift', checked: true },
    {
      name: 'Tuition',
      value: 'tuition',
      icon: 'fas fa-graduation-cap',
      checked: true,
    },
    { name: 'Pets', value: 'pets', icon: 'fas fa-paw', checked: true },
  ];

  public selectedCategoryIds: Array<number> = [];

  public allBottomProducts: {
    currentPage: number;
    data: Array<any>;
    lastPage: number;
    totalCount: number;
  } = {
    currentPage: 1,
    data: [],
    lastPage: 1,
    totalCount: 0,
  };

  filteredBottomProducts: any = [];
  public bottomProductsSubCategory = '';
  public bottomProductsSubCategoryId = null;
  public imgUrl = environment.ImageUrl;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['userRegionId']) {
      this.userRegionId = changes['userRegionId'].currentValue;
      if (this.userRegionId) {
        this.loadProducts();

        if (this.sharedService.isBrowser()) {
          this.fetchPromos();
        }
      }
    }

    if (changes['hiddenCategoryTab']) {
      this.hiddenCategoryTab = changes['hiddenCategoryTab'].currentValue;
      if (this.hiddenCategoryTab) {
        this.tabs = this.tabs.map((tab) => {
          if (this.hiddenCategoryTab.includes(tab.name)) {
            tab.hidden = true;
            tab.checked = false;
          } else {
            tab.checked = true;
            tab.hidden = false;
          }
          return tab;
        });
        this.cdr.detectChanges();
      }
    }
  }

  ngOnDestroy(): void {
    this.$destroy.next();
    this.$destroy.complete();
  }

  memberShopProductList: any = [];

  public isLoading: boolean = true;
  public showtCarousel = true;
  public productIds: Array<number> = [];
  public async refreshBottomProducts(page: number = 1, resetCarousel = false) {
    if (resetCarousel) {
      this.showtCarousel = false;
      this.cdr.detectChanges();
    }

    let params: any = {
      orderBy: this.selectedTab,
    };

    // Check if Tabs is Category
    const validCategory = [
      'food-beverage',
      'cuisine',
      'tuition',
      'pets',
      'local-delights',
    ];
    // if (validCategory.includes(this.selectedTab)) {
    //   await this.getCategory(this.selectedTab)
    //   params = {
    //     categoryId: this.selectedCategoryIds
    //   }
    // }

    if (this.userRegionId == null) {
      this.allBottomProducts = {
        currentPage: 1,
        data: [],
        lastPage: 1,
        totalCount: 0,
      };
      this.isLoading = false;
      this.showtCarousel = true;
      this.cdr.detectChanges();
      return;
    }
    if (this.selectedTab == 'free') {
      params = {
        orderBy: 'donate',
      };
    }

    this.isLoading = true;
    this.customerService
      .getMemberShopProductList({
        isAdmin: false,
        page: page,
        basedProduct: 'all',
        subRegionId: this.userRegionId,
        limit: 20,
        ...params,
      })
      .pipe(takeUntil(this.$destroy))
      .subscribe({
        next: (data: any) => {
          data = data.body;
          if (data.currentPage === 1) this.allBottomProducts.data = [];
          if (data?.data)
            this.allBottomProducts = {
              ...data,
              data: [...this.allBottomProducts.data, ...data?.data],
            };
          this.isLoading = false;
          this.showtCarousel = true;
          this.productIds = this.allBottomProducts.data.map((item) => item.id);
          const getDistance = (prod, userLatLong) => {
            let latLong = prod?.latLong;
            if (typeof latLong == 'string') {
              try {
                latLong = JSON.parse(latLong);
              } catch (e) {}
            
            }
            const rv = this.local.isWithinRadius(latLong, userLatLong, 5);
            //console.log({ rv });
            return rv;
          };
          this.allBottomProducts.data.sort((a, b) => {
            let userLatLong = this.local.getUser()?.latLong;
            if (typeof userLatLong == 'string') {
              try {
                userLatLong = JSON.parse(userLatLong);
              } catch (e) {
                console.error(e);
              }
            }

            const infoB = this.commonService.getProductInformationScore(b);
            const infoA = this.commonService.getProductInformationScore(a);

            let distanceA = getDistance(a, userLatLong)?.realDistance;
            let distanceB = getDistance(b, userLatLong)?.realDistance;
            
            if(!distanceA){
              distanceA = 5
            }

            if(!distanceB){
              distanceB = 5
            }

            const distanceDiff = distanceA - distanceB;
           // console.log({ distanceA, distanceB });

            if (distanceDiff) {
              return distanceDiff  ;
            }
            return infoA - infoB;
          });
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.isLoading = false;
          this.showtCarousel = true;
          this.cdr.detectChanges();
        },
      });
  }

  loadProducts(tab: string = 'popular') {
    if (tab != this.selectedTab) {
      this.selectedTab = tab;
      this.refreshBottomProducts(1, true);
    }
  }

  async getCategory(slug: string) {
    this.selectedCategoryIds = [];
    return new Promise((resolve, reject) => {
      this.commonService.categoryList.subscribe({
        next: (res: any) => {
          console.log(res, 'ALL CATEGORY');
          const category = res.find((i: any) => i.slug == slug);
          console.log(category);
          if (category) {
            this.selectedCategoryIds = category.subCategory.map(
              (i: any) => i.categorieChildId,
            );
            this.cdr.detectChanges();
            resolve(this.selectedCategoryIds);
          } else {
            resolve([]);
          }
        },
        error: (error) => {
          reject(error);
        },
      });
    });
  }

  public saveProfileInfo(): void {
    let payload: any = {};

    payload.hiddenCategoryTab = this.tabs
      .filter((row: any) => !row.checked)
      .map((row: any) => row.name)
      .join('|');

    console.log('payload', payload);
    const formData = new FormData();

    Object.keys(payload).map((row) => {
      if (typeof payload[row] === 'boolean') {
        formData.append(row, payload[row] ? '1' : '0');
      } else {
        formData.append(row, payload[row]);
      }
    });

    this.auth.updateProfileCharacterDetails(formData).subscribe(
      (resp: ApiResponse) => {
        if (resp.message) {
          this.toastr.success(resp.message);
          this.store.dispatch(loadUser({}));
        }
      },
      ({ error }) => {
        this.toastr.error(error.message);
      },
    );
  }

  public openManageTabsModal(modal: any) {
    this.modalRef = this.modalService.open(modal, { centered: true });
  }

  handleReport() {
    this.local.alertReport().then((result) => {
      if (result.isConfirmed && result.value) {
        const report = result.value;
        this.auth
          .submitReportMessage({
            message: report.reportDetails,
            type: report.reportType,
            category: 'member',
            product_id: this.userId,
          })
          .subscribe(
            () => {
              this.toastr.success('Reported successfully');
            },
            (e) => {
              this.toastr.error(e.error.message);
            },
          );
      }
    });
  }
}
